import { render, staticRenderFns } from "./indexFeaturedExhibitors.vue?vue&type=template&id=bb89e3da&scoped=true&"
import script from "./indexFeaturedExhibitors.vue?vue&type=script&lang=js&"
export * from "./indexFeaturedExhibitors.vue?vue&type=script&lang=js&"
import style0 from "./indexFeaturedExhibitors.vue?vue&type=style&index=0&id=bb89e3da&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb89e3da",
  null
  
)

export default component.exports